// extracted by mini-css-extract-plugin
module.exports = {"shadow":"Summary_shadow__23A6b","summary":"Summary_summary__9VnVo","header":"Summary_header__3f0DL","tabContainer":"Summary_tabContainer__3jwGU"};